import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	license :
	{
		employeeInfo : {
			limit : 0,
			used  : 0
		},
		relationInfo : {
			limit : 0,
			used  : 0
		},
		mediaInfo : {
			limit : 0,
			used  : 0
		}
	},
	cnctnAlert : true

};

export const licenseSlice = createSlice({
	name     : 'license',
	initialState,
	reducers : {
		setLicenseData : (state, action) =>
		{
			state.license = { ...state.license, ...action.payload };
		},
		setCtnAlert : (state, action) =>
		{
			state.cnctnAlert = action?.payload;
		}
	}
});

export const { setLicenseData, setCtnAlert } = licenseSlice.actions;
export default licenseSlice.reducer;